<template>
	<tr
		class="ms-tr"
		tabindex="0"
		@keydown="row_keydown"
		:class="dataRow.isSelected ? 'ms-tr-hover' : ''"
	>
		<td v-if="serial" class="ms-td serial text-center">{{ rowIndex + 1 }}</td>
		<td v-if="multiple" class="ms-td multiple-cell">
			<ms-checkbox
				:checked="isSelected"
				class="center"
				ref="multiple"
				checkOnly
				@click="checkMultiple"
			/>
		</td>
		<td
			v-for="(col, colIndex) in modifiedColumns"
			:key="col.dataField"
			class="ms-td"
			@click="cell_click(col, colIndex)"
			@dblclick="cell_dblclick"
			:style="styleWidth(col)"
		>
			<component
				:is="getEditorType(col)"
				:ref="`editor-${colIndex}`"
				:col="col"
				:dataRow="dataRow"
				:rowIndex="rowIndex"
				:colIndex="colIndex"
				:editable="editable"
				:rowSelected="rowSelected"
				:disabledLst="disabledLst"
				:isBlurAction="isBlurAction"
				:gridInfo="gridInfo"
				v-on="listeners"
				:customProperty="col.customProperty"
			></component>
		</td>
		<td
			v-if="widgetOptions"
			class="ms-td widget-item"
			:style="styleWidth(widgetOptions)"
			:class="widgetOptions.class"
		>
			<component
				:is="widgetOptions.components"
				:dataRow="dataRow"
				@widgetEvent="widgetEvent"
				:rowIndex="rowIndex"
			></component>
		</td>
	</tr>
</template>
<script>
import msCellInput from './mscelleditor/msCellInput.vue';
import msCellInstruction from './mscelleditor/msCellInstruction.vue';
import msCellCombobox from './mscelleditor/msCellCombobox.vue';
import msCellNumber from './mscelleditor/msCellNumber.vue';
import msCellCheckbox from './mscelleditor/msCellCheckbox.vue';
import msCellDatepicker from './mscelleditor/msCellDatepicker.vue';
import msCellDatepickerV2 from './mscelleditor/msCellDatepickerV2.vue';
import msCellDropdown from './mscelleditor/msCellDropdown.vue';
import msCellComboboxWithDifferentValue from './mscelleditor/msCellComboboxWithDifferentValue.vue';

export default {
	name: 'msTr',
	props: {
		//Lưu thông tin của các cột
		columns: {},
		//Lưu dữ liệu của dòng
		dataRow: {},
		//Lưu cấu hình của cột chức năng
		widgetOptions: {},
		//Ẩn/hiện cột checkbox tích chọn nhiều cột
		multiple: {
			default: false,
			type: Boolean,
		},
		rowIndex: {
			default: 0,
			type: Number,
		},
		//Trạng thái tích chọn ở cột multiple
		isSelected: {
			default: false,
			type: Boolean,
		},
		//Thuộc tính cấu hình hiện thị cột STT
		serial: {
			default: false,
			type: Boolean,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		rowSelected: {
			default: null,
		},
		disabledLst: [],
		isHoverTr: {
			default: true,
			type: Boolean,
		},
		editableByRowAction: {
			default: false,
			type: Boolean,
		},
		isBlurAction: {
			default: true,
			type: Boolean,
		},
		gridInfo: {},
		isCustomColumns: {
			default: false,
			type: Boolean,
		},
	},
	components: {
		msCellInput,
		msCellCombobox,
		msCellNumber,
		msCellCheckbox,
		msCellDatepicker,
		msCellDropdown,
		msCellComboboxWithDifferentValue,
		msCellDatepickerV2,
		msCellInstruction
	},
	computed: {
		listeners() {
			const me = this;
			return {
				selected: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('selected', metaData);
				},
				change: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					metaData._tr = me;
					metaData.callBackFunc = (cellErrorProvider) => {
						//gắn dữ liệu vào metaData để sử dụng trong validateAfterChange;
						metaData.cellErrorProvider = me.$ms.commonFunc.cloneDeepData({
							message: cellErrorProvider.message,
							isValid: cellErrorProvider.isValid,
							rules: cellErrorProvider.rules,
						});
					};
					me.$emit('change', metaData);
					//validateAfterChange
					me.validateAfterChange(metaData);
				},
				rowSelected: (data) => {
					data.rowIndex = me.rowIndex;
					me.$emit('rowSelected', data);
				},
				loadDataCombo: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('loadDataCombo', metaData);
				},
				blur: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('blur', metaData);
				},
				next: () => {
					let data = { rowIndex: me.rowIndex };
					me.$emit('next', data);
				},
				changeCombobox: (payload) => {
					if (payload) {
						let metaData = payload.metaData;
						metaData.rowIndex = me.rowIndex;
						metaData._tr = me;
						me.$emit('change', metaData);
					}
					me.$emit('changeCombobox', { ...payload, _tr: me });
				},
			};
		},
	},
	data() {
		return {
			modifiedColumns: [...this.columns], // Tạo bản sao của props columns
		};
	},
	methods: {
		testRender() {},
		//Cập nhật lại width cho cell khi width của col bị thay đổi
		//Created by LTDAT (30.06.2020)
		styleWidth(col) {
			const me = this;
			if (col.autoResize) {
				return { 'min-width': `${col.width}px` };
			} else {
				return { width: `${col.width}px`, 'min-width': `${col.width}px` };
			}
		},
		//Lấy lại control editor
		//Created by LTDAT (17.06.2020)
		getEditorType(col) {
			const me = this;
			switch (col.columnType) {
				case 'combobox':
					return 'msCellCombobox';
				case 'input':
					return 'msCellInput';
				case 'number':
					return 'msCellNumber';
				case 'checkbox':
					return 'msCellCheckbox';
				case 'datepicker':
					return 'msCellDatepicker';
				case 'datepickerv2':
					return 'msCellDatepickerV2';
				case 'dropdown':
					return 'msCellDropdown';
				case 'template':
					return col.template;
				case 'comboboxDifferentValue':
					return 'msCellComboboxWithDifferentValue';
				case 'instruction':
					return 'msCellInstruction';
				default:
					return 'msCellInput';
			}
		},
		//Emit sự kiện từ widget ra ngoài
		// Created by LTDAT (16.06.2020)
		widgetEvent(data, event) {
			const me = this;
			if (data) {
				data.rowIndex = me.rowIndex;
			}

			if (me.editableByRowAction) {
				let editor = me.$refs[`editor-${0}`];
				data.editor = editor[0];
			}

			//Custom lại columns
			if (me.isCustomColumns && me.gridInfo) {
				me.$set(me.gridInfo, 'columns', me.modifiedColumns);
				me.resetEditorInColumns(me.columns, me.rowIndex);
			}
			me.$emit('widgetEvent', data, event);
		},
		//Emit sự kiện click row ra ngoài grid
		//Created by LTDAT(13/06/2020)
		cell_click(col, colIndex) {
			const me = this;
			let editor = me.$refs[`editor-${colIndex}`];
			me.$emit('click', editor[0]);
		},
		//Emit sự kiện dblclickRow ra ngoài grid
		//Created by LTDAT(13/06/2020)
		cell_dblclick(e) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };
			me.$emit('dblclick', dataRow, e);
		},
		//Emit sự kiện ấn phím ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_keydown(e) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };
			me.$emit('keydown', dataRow, e);
		},
		//Sự kiện click vào nút chọn ở cột multiple
		//Created by LTDAT (28.05.2020)
		checkMultiple(event) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };
			me.$emit('clickMultiple', dataRow);
		},

		updateColumn() {},
		resetEditorInColumns(cols, rowIndex) {
			const me = this;
			if (!cols || cols.length <= 0) return cols;

			cols.forEach((col, index) => {
				let colResult = me.resetEditorInColumn(col, rowIndex);
				me.$set(me.modifiedColumns, index, colResult);
			});
		},
		resetEditorInColumn(col, rowIndex) {
			const me = this;
			if (!col || rowIndex < 0) return;

			//Loại bỏ key action hiện tại
			if (
				col[`__editor_${rowIndex}`] &&
				Object.keys(col[`__editor_${rowIndex}`]).length > 0
			) {
				delete col[`__editor_${rowIndex}`];
			}

			//Cập nhật lại danh sách các key
			const keys = Object.keys(col).sort();
			const newCol = {};
			let editorIndex = 0;
			for (let i = 0; i < keys.length; i++) {
				if (keys[i].startsWith('__editor_')) {
					newCol[`__editor_${editorIndex}`] = col[keys[i]];
					editorIndex++;
				} else {
					newCol[keys[i]] = col[keys[i]];
				}
			}

			return newCol;
		},

		validateAfterChange(metaData) {
			const me = this;
			if (
				!metaData ||
				!metaData.dataCheck ||
				Object.keys(metaData.dataCheck).length <= 0
			) {
				return;
			}

			switch (metaData.dataCheck.name) {
				case me.$ms.enum.ColumnValidateType.MsCellDatePickerV2:
					if (!metaData.dataCheck.fromDate || !metaData.dataCheck.toDate) {
						me.validateRow(metaData);
					}
					break;
			}
		},

		validateRow(metaData) {
			const me = this;
			if (
				!metaData ||
				!metaData.cellErrorProvider ||
				!metaData.cellErrorProvider.isValid ||
				!metaData.cellErrorProvider.message ||
				!metaData.dataCheck ||
				!me.columns ||
				me.columns.length <= 0
			)
				return;

			let data = metaData.dataCheck;
			let keyCol =
				data.keyFromDate == data.dataField ? data.keyToDate : data.keyFromDate;
			let colInfoIndex = me.columns.findIndex(
				(col) => col.dataField === keyCol
			);
			if (colInfoIndex <= -1) return;
			let editor =
				me.$refs[`editor-${colInfoIndex}`] &&
				me.$refs[`editor-${colInfoIndex}`][0]
					? me.$refs[`editor-${colInfoIndex}`][0]
					: null;
			if (editor) {
				editor.validateCell();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
</style>